// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NicheDescription {
  display: flex;
  flex-direction: row;
  column-gap: 8px;
}
.NicheDescription span {
  padding-top: 4px;
  color: var(--color_neutral_500);
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/modules/niche/niche-description/niche-description.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AACF;AACE;EACE,gBAAA;EACA,+BAAA;EACA,eAAA;AACJ","sourcesContent":[".NicheDescription {\n  display: flex;\n  flex-direction: row;\n  column-gap: 8px;\n\n  span {\n    padding-top: 4px;\n    color: var(--color_neutral_500);\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
